import React, { FC } from 'react';
import BidTaskHeader from '../BidTaskHeader';
import BidTaskToolbar from '../BidTaskToolbar';
import TaskEditor from '../TaskEditor';
import { TaskProvider } from 'src/models/bids/BidTask/providers';
import styles from './index.module.scss';
import { Footer, FooterView } from 'src/common';

export const TaskContent: FC = () => (
  <div className={styles.container}>
    <TaskProvider>
      <div className={styles.actions}>
        <BidTaskHeader />
        <BidTaskToolbar />
      </div>
      <div className={styles.content}>
        <TaskEditor />
      </div>
    </TaskProvider>
    <Footer view={FooterView.logo} />
  </div>
);

export default TaskContent;
